import { __decorate } from "tslib";
import { throttle } from 'helpful-decorators';
import $ from 'jquery';
import { Breakpoint } from '../types/breakpoint';
import { getCurrentBreakpoint } from '../utils/breakpoint';
import { checkWebpSupport } from '../utils/webp';
import LazyImages from './lazy-images';
export default class BackgroundImage {
    static $bgImageElement;
    static isWebpSupported;
    static async init() {
        this.$bgImageElement = $('.js__bg-image');
        if (!this.$bgImageElement.length) {
            return;
        }
        this.isWebpSupported = await checkWebpSupport();
        $(window).on('resize', () => {
            this.actionsOnResize();
        });
        this.initBgImagesLoading();
    }
    static initBgImagesLoading() {
        this.$bgImageElement.each((key, item) => {
            this.displayImage($(item));
        });
    }
    static actionsOnResize() {
        // TODO: execute this only if breakpoint has changed from mobile to desktop or vice versa.
        this.initBgImagesLoading();
    }
    static displayImage($bgElement) {
        const imagePath = this.getImagePath($bgElement);
        const currentBreakpoint = getCurrentBreakpoint();
        if (imagePath) {
            this.addImageToBackground($bgElement, imagePath);
        }
        else if (currentBreakpoint < Breakpoint.lg && $bgElement.data('hide-mobile-image')) {
            this.removeBackgroundImage($bgElement);
        }
    }
    static getImagePath($bgElement) {
        const currentBreakpoint = getCurrentBreakpoint();
        const isMobileImageExist = $bgElement.data(`bg-image-mobile`);
        const webpSuffix = this.isWebpSupported ? '-webp' : '';
        if ($bgElement.data('hide-mobile-image') && currentBreakpoint < Breakpoint.lg) {
            return '';
        }
        return !isMobileImageExist || currentBreakpoint >= Breakpoint.lg
            ? $bgElement.data(`bg-image${webpSuffix}`)
            : $bgElement.data(`bg-image-mobile${webpSuffix}`);
    }
    static addImageToBackground($bgElement, imagePath) {
        // TODO: do not do anything if new bg url is the same as previous.
        if ($bgElement.hasClass('lazy')) {
            $bgElement.attr('data-was-processed', 'false');
            $bgElement.attr('data-bg', `url(${imagePath})`);
            LazyImages.updateBackground();
        }
        else {
            $bgElement.css('backgroundImage', `url(${imagePath})`);
        }
    }
    static removeBackgroundImage($bgElement) {
        $bgElement.css('background-image', '');
    }
}
__decorate([
    throttle(300)
], BackgroundImage, "actionsOnResize", null);
